<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M2.25 5C2.25 4.58579 2.58579 4.25 3 4.25H17C17.4142 4.25 17.75 4.58579 17.75 5C17.75 5.41421 17.4142 5.75 17 5.75H3C2.58579 5.75 2.25 5.41421 2.25 5Z"
            fill="currentColor"
        />
        <path
            d="M2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H17C17.4142 9.25 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10Z"
            fill="currentColor"
        />
        <path
            d="M3 14.25C2.58579 14.25 2.25 14.5858 2.25 15C2.25 15.4142 2.58579 15.75 3 15.75H17C17.4142 15.75 17.75 15.4142 17.75 15C17.75 14.5858 17.4142 14.25 17 14.25H3Z"
            fill="currentColor"
        />
    </svg>
</template>
